/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: new-delivery-endpoint-modal-component.js
 *
 * Created by rsorensen-lb on 5/12/17.
 */

'use strict';

function NewDeliveryEndpointModalController (PartnerEditService) {
	var self = this;

	self.$onInit = function () {
		self.supportedEndpointTypes = self.resolve.supportedEndpointTypes;
		self.selectedEndpointType = '';
	};

	self.onCreate = function () {
		self.close({$value: self.selectedEndpointType});
	};

	self.onCancel = function () {
		self.dismiss({$value: 'cancel'});
	};

	self.canCreate = function () {
		return self.selectedEndpointType !== '' && !self.modalForm.$pristine;
	};

	self.getLabel = function (endpointType) {
		return PartnerEditService.getEndpointTypeLabel(endpointType);
	};
}

angular.module('prism-ui.partner').component('newDeliveryEndpointModal', {
	templateUrl: 'system/partner/editor/components/view/deliveryEndpoints/searchView/modals/new-delivery-endpoint-modal-template.html',
	controller: NewDeliveryEndpointModalController,
	bindings: {
		resolve: '<',

		// these correspond to their synonymous counterparts in
		// $uibModalInstance and are automatically provided by
		// $uibModal.open()
		close: '&',
		dismiss: '&'
	}
});
